export const addAdditionalInfo = () => {
  jQuery('.create-account-page .account-form__header').append('<p class="account-form__header__subtitle">*Datos obligatorios para crear la cuenta</p>');

  jQuery('.create-account-page .tel-group.form-group').closest('.row.row--flex').after(`
    <div class='tel-message'>
      <p>
        Para poder recuperar tu contraseña y acceder con tu número deberá ser un teléfono móvil
      </p>
    </div>
  `);
};



// WEBPACK FOOTER //
// ./src/_override/shared/create-account/addAdditionalInfo.js